module.exports = __webpack_public_path__ + "img/top-image-1264x712.6e81decc.jpg";